import Vue from 'vue'
import './theme/assets/styles.css'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import toaster from './plugins/toaster'
import VueObserveVisibility from 'vue-observe-visibility'
import { HasRoleDirective, HasPermissionDirective } from './directives'
import './filters'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'

Vue.config.productionTip = false

// Ignorar elementos personalizados de Stripe (Web Components)
Vue.config.ignoredElements = [
  'stripe-pricing-table'
]

Vue.use(toaster, store)
Vue.use(VueObserveVisibility)
Vue.directive('has-role', HasRoleDirective)
Vue.directive('has-permission', HasPermissionDirective)

new Vue({
  router,
  store,
  vuetify,
  onIdle () {
    // cerrando la sesión del usuario luego de 30 mins de inactividad en el sistema
    store.dispatch('LOGOUT')
    if (router.currentRoute.name !== 'Login') {
      router.push({ name: 'Login' })
    }
  },
  render: h => h(App)
}).$mount('#app')
